import {
  faBehance,
  faDribbble,
  faFacebook,
  faInstagram,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link, graphql, useStaticQuery } from "gatsby"
import { useLocation } from "@reach/router"
import React, { useCallback, useEffect, useMemo, useState } from "react"
import BlackArrow from "../assets/img/down-arrow-black.inline.svg"
import TechuzLogoBlack from "../assets/img/techuz-logo.png"
import { useContextValues } from "../context/NavBarContext"

import animatedIcon from "../assets/img/Contact-us-animation4.gif"
import animatedIconWhite from "../assets/img/Contact-us-animation-white.gif"
import { StaticImage } from "gatsby-plugin-image"

const Header = () => {
  let {
    allTechnologiesJson: { technologies },
    allTechnologiesExtraJson: { technologiesExtra },
    allServicesJson: { services }
  } = useStaticQuery(graphql`
    query {
      allTechnologiesJson {
        technologies: nodes {
          slug
        }
      }
      allTechnologiesExtraJson {
        technologiesExtra: nodes {
          slug
        }
      }
      allServicesJson {
        services: nodes {
          slug
        }
      }
    }
  `)

  const serviceSlugs = [] as Array<string>
  technologies.map(({ slug }) => serviceSlugs.push(slug))
  technologiesExtra.map(({ slug }) => serviceSlugs.push(slug))
  services.map(({ slug }) => serviceSlugs.push(slug))

  const [isShown, setIsShown] = useState(false)
  const [showMenu, setShowMenu] = useState(false)
  const [isExpanded, setIsExpanded] = useState({})
  const [selectedCategory, setSelectedCategory] = useState({})
  const { isMobile, navColor, navPosition, changeNavPosition, currentPath, absoluteNav } =
    useContextValues()
  const [colorChange, setColorchange] = useState(false)

  const { pathname } = useLocation()

  const isWhiteNav = useMemo(
    () => (navColor === "white" ? true : false),
    [navColor]
  )
  const toggleMenu = () => {
    if (isMobile) {
      setShowMenu(prev => !prev)
      document.body.style.overflowY = showMenu ? 'auto' : 'hidden'
      if (currentPath === '/') {
        changeNavPosition(showMenu ? 'absolute' : 'fixed')
      }
    }
  }
  const getToggleMeClass = id => {
    setIsExpanded({
      [id]: isExpanded[id] === undefined ? true : !isExpanded[id],
    })
  }
  const getToggleCategoryClass = id => {
    setSelectedCategory({
      [id]: selectedCategory[id] === undefined ? true : !selectedCategory[id],
    })
  }
  const menuClass = useMemo(() => {
    if (showMenu && isMobile) {
      return "z-999 fixed left-0 top-0 w-full h-full z-10 md:static md:w-auto md:h-auto md:block bg-white-200 md:bg-transparent overflow-y-scroll md:overflow-y-hidden overflow-x-hidden menu-open"
    }
    return "z-999 fixed w-full h-full z-10 md:static md:w-auto md:h-auto md:block hidden bg-white-200 md:bg-transparent overflow-y-scroll md:overflow-y-visible"
  }, [showMenu, isMobile])

  const activePageClass = useCallback((page: 'company' | 'services' | 'portfolio' | 'careers' | 'blog') => {
    if (pathname.includes('web-development-company')) {
      return ''
    }
    if (page === 'services') {
      return serviceSlugs.some(service => pathname.includes(service)) ? 'before:!w-[calc(100%-17px)]' : ''
    }
    return pathname.includes(page) ? 'before:!w-full' : ''
  }, [pathname])

  const changeNavbarColor = () => {
    setColorchange(window.scrollY >= 60)
  }

  useEffect(() => {
    const bindChangeNavBar = !absoluteNav.includes(currentPath)
    bindChangeNavBar &&
      window.addEventListener("scroll", changeNavbarColor, { passive: true })
    return () => {
      setColorchange(false)
      bindChangeNavBar &&
        window.removeEventListener("scroll", changeNavbarColor)
    }
  }, [currentPath])

  return (
    <header
      className={`py-4 ${navPosition} w-full z-20 ${colorChange || isWhiteNav ? " bg-white-200" : "bg-transparent"
        } ${showMenu ? '!bg-white-200 top-0' : ''}`}
    >
      <div className="container flex items-center lg:px-[1.875rem] px-4">
        <div className="logo max-w-[8.625rem] lg:mr-[3.875rem] mr-3 relative z-50">
          <Link to="/" className={!showMenu ? undefined : "hidden"}>
            <img
              src={
                colorChange || isWhiteNav ? TechuzLogoBlack : TechuzLogoBlack
              }
              width="110"
              height="32"
              alt="Techuz Infoweb"
            />
          </Link>
          <Link
            to="/"
            onClick={toggleMenu}
            className={` ${showMenu ? undefined : "hidden"}`}
          >
            <img
              src={TechuzLogoBlack}
              alt="Techuz Infoweb"
              className="max-w-[110px] object-contain"
              width="110"
              height="31.89"
            />
          </Link>
        </div>
        <div className="menu flex-1 z-999 justify-end inline-flex max-[767px]:pr-12">
          {/* <Link
            to="/contact-us/"
            className="md:hidden inline-flex items-center inline-white text-black border border-black text-sm rounded-3xl pl-2 py-1 pr-[0.313rem] font-gorditamedium hover:bg-primary hover:border-primary hover:text-white "
          >
            Contact Us
            <span className="flex w-5 h-5 bg-primary justify-center items-center rounded-full ml-2">
              <StaticImage src="../assets/img/edit.svg" alt="" />
            </span>
          </Link> */}
          {!showMenu && <Link
            to="/contact-us/"
            className="md:hidden inline-flex items-center bg-white-200 justify-between inline-white text-black border border-black shadow-1xl max-sm:text-sm max-sm:leading-[1.313rem] text-base m-auto rounded-3xl pl-5 py-1 pr-1 font-gorditamedium hover:bg-transparent hover:border-primary group"
          >
            Contact Us
            <span className="inline-flex w-[1.875rem] h-[1.875rem] bg-primary border-2 border-primary justify-center items-center rounded-full ml-[0.625rem] ease-in duration-300 group-hover:bg-transparent relative">
              <img
                src={animatedIconWhite}
                alt=""
                className="w-5 h-5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-100 visible group-hover:opacity-0 group-hover:invisible transition-all ease-in duration-300"
              />
              <img
                src={animatedIcon}
                alt=""
                className="w-5 h-5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all ease-in duration-300"
              />
            </span>
          </Link>}
          {showMenu ? (
            <button
              type="button"
              onClick={toggleMenu}
              aria-label="menu"
              className=" icon md:hidden block w-9 h-9 rounded-full border border-black absolute right-4 top-4 z-50"
            >
              <span className="absolute bg-black w-4 h-0.5 left-0 right-0 mx-auto rotate-[45deg] before:rotate-[-90deg] before:absolute before:content-[''] before:bg-black before:w-4 before:h-0.5 before:-top-0 before:left-0 before:right-0 before:mx-auto after:absolute after:content-[''] after:bg-black after:w-4 after:h-0.5 after:-bottom-[0.350rem] after:left-0 after:right-0 after:mx-auto after:opacity-0" />
            </button>
          ) : (
            <button
              onClick={toggleMenu}
              type="button"
              aria-label="menu"
              className=" icon md:hidden block w-9 h-9 rounded-full border border-black absolute right-4 top-4 z-50"
            >
              <span className="absolute bg-black w-4 h-0.5 left-0 right-0 mx-auto before:absolute before:content-[''] before:bg-black before:w-4 before:h-0.5 before:-top-[0.350rem] before:left-0 before:right-0 before:mx-auto after:absolute after:content-[''] after:bg-black after:w-4 after:h-0.5 after:-bottom-[0.350rem] after:left-0 after:right-0 after:mx-auto" />
            </button>
          )}
          <div className={`z-999 ${menuClass}`}>
            <nav className="flex items-center justify-end md:flex-nowrap flex-wrap md:p-0 py-10 pt-[6.5rem] px-4 nav-bar">
              <ul className="flex items-center md:flex-nowrap flex-wrap md:w-auto w-full">
                <li className="lg:mx-4 md:mx-2 md:my-0 my-3.5 md:text-center text-left md:w-auto w-full">
                  <Link
                    to="/company/"
                    onClick={toggleMenu}
                    className={`text-black md:text-base text-2xl font-gorditamedium group relative before:content[''] before:absolute before:left-0 before:bottom-[-4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden
                     ${colorChange || isWhiteNav
                        ? " md:text-black"
                        : "md:text-black"
                      } ${activePageClass('company')}`}
                  >
                    <span className="relative">Company</span>
                  </Link>
                </li>

                <li
                  onMouseEnter={() => setIsShown(true)}
                  onMouseLeave={() => setIsShown(false)}
                  className="group relative lg:px-4 md:px-2 md:my-0 my-3.5 md:py-[10px] md:text-center text-left md:w-auto w-full"
                >
                  <span
                    className=" md:text-black text-white md:text-base text-2xl hover:text-primary font-gorditamedium group flex items-center"
                    onClick={() => getToggleCategoryClass("services")}
                  >
                    <span
                      className={`text-black cursor-pointer flex items-center after:relative after:ml-3 after:text-black md:after:hidden after:block relative before:content[''] before:absolute before:left-0 before:bottom-[0px] before:w-0 before:h-[2px] before:bg-black hover:before:w-[calc(100%-17px)] max-md:before:hidden ${selectedCategory["services"]
                        ? "after:content-['-']"
                        : "after:content-['+']"
                        } ${colorChange || isWhiteNav
                          ? " md:text-black"
                          : "md:text-black"
                        } ${activePageClass('services')}`}
                    >
                      Services
                      <span className="hidden md:flex ">
                        <BlackArrow className="ml-1.5 w-3 h-2 hidden md:block max-w-[0.688rem]" />
                      </span>
                    </span>
                  </span>
                  {(isShown || (isMobile && selectedCategory["services"])) && (
                    <div
                      className={`transition-all duration-700 pt-4 md:pt-10 group-hover:opacity-100 group-hover:pointer-events-auto
                        md:opacity-0 opacity-100 z-10 w-[45.938rem] md:bg-[#fff] md:drop-shadow-[0px_32px_83px_rgba(0,0,0,0.07)] ${selectedCategory["services"] ? "block" : "hidden"
                        } md:block top-[2.8rem] rounded-[0.625rem] md:absolute md:left-1/2 md:translate-x-[-50%] md:py-10 py-0 md:px-12 px-0 md:before:[''] md:before:block before:hidden before:absolute before:top-[-10px] before:left-1/2 before:translate-x-[-100%] before:w-0 before:h-0 before:border-l-[10px] before:border-l-transparent before:border-r-[10px] before:border-r-transparent before:border-b-[10px] before:border-b-[#fff]`}
                    >
                      <div
                        className={`md:flex text-left flex justify-between flex-wrap md:flex-nowrap ${selectedCategory["services"] ? "block" : "hidden"
                          }`}
                      >
                        <div className="md:w-auto w-full md:min-w-[30%]">
                          <div>
                            <h6 className="text-lg text-black font-blancomedium mb-4 hidden md:block">
                              Web
                              <span className="inline-block text-orangecol">.</span>
                            </h6>
                            <ul className="md:mb-5 mb-0">
                              <li
                                onClick={() => {
                                  getToggleMeClass("javascript-development")
                                }}
                                className={`text-black font-gorditamedium text-base leading-[1.87rem] mb-2 relative ${isExpanded["javascript-development"]
                                  ? "after:content-['-'] text-black"
                                  : "after:content-['+'] text-black"
                                  } after:relative after:ml-3 after:text-black md:after:hidden after:inline-block block`}
                              >
                                JavaScript Development
                              </li>
                              <li
                                className={`md:flex flex-col items-start block md:mb-0 mb-3 ${isExpanded["javascript-development"]
                                  ? "block"
                                  : "hidden"
                                  }`}
                              >
                                <Link
                                  to="/angular-js-development/"
                                  onClick={toggleMenu}
                                  className=" text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Angular&nbsp;JS
                                </Link>
                                <Link
                                  to="/react-js-development/"
                                  onClick={toggleMenu}
                                  className=" text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  React&nbsp;JS
                                </Link>
                                <Link
                                  to="/node-js-development/"
                                  onClick={toggleMenu}
                                  className=" text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Node&nbsp;JS
                                </Link>
                                <Link
                                  to="/vue-js-development/"
                                  onClick={toggleMenu}
                                  className=" text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Vue&nbsp;JS
                                </Link>
                                <Link
                                  to="/meteor-development/"
                                  onClick={toggleMenu}
                                  className=" text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Meteor&nbsp;JS
                                </Link>
                              </li>
                            </ul>

                            <ul>
                              <li>
                                <div
                                  onClick={e => getToggleMeClass("web-development")}
                                  className={`text-black font-gorditamedium text-base leading-[1.87rem] mb-2 relative ${isExpanded["web-development"]
                                    ? "after:content-['-'] text-black"
                                    : "after:content-['+'] text-black"
                                    } after:relative after:ml-3 after:text-[#484848] md:after:hidden after:inline-block cursor-pointer block`}
                                >
                                  <Link to="/web-development/" onClick={toggleMenu}>
                                    Web Development
                                  </Link>
                                </div>
                              </li>
                              <li
                                className={`md:flex flex-col items-start block ${isExpanded["web-development"]
                                  ? "block"
                                  : "hidden"
                                  }`}
                              >
                                <Link
                                  to="/php-web-development/"
                                  onClick={toggleMenu}
                                  className=" text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  PHP
                                </Link>
                                <Link
                                  to="/laravel-web-development/"
                                  onClick={toggleMenu}
                                  className=" text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Laravel
                                </Link>
                                <Link
                                  to="/codeigniter-development/"
                                  onClick={toggleMenu}
                                  className=" text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Codeigniter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="md:w-auto w-full md:min-w-[30%]">
                          <div className="md:mb-[3rem] mb-0">
                            <h6 className="text-lg text-black font-blancomedium mb-4 hidden md:block">
                              Mobile
                              <span className="inline-block text-orangecol">.</span>
                            </h6>
                            <ul>
                              <li>
                                <Link
                                  to="/mobile-application-development/"
                                  onClick={e => getToggleMeClass("mobile-development")}
                                  className={` md:text-black font-gorditamedium text-base leading-[1.87rem] mb-2 relative ${isExpanded["mobile-development"]
                                    ? "after:content-['-'] text-black"
                                    : "after:content-['+'] text-black"
                                    } after:relative after:ml-3 after:text-black md:after:hidden after:inline-block cursor-pointer block`}
                                >
                                  <Link to="/mobile-application-development/" onClick={toggleMenu}>
                                    Mobile Development
                                  </Link>
                                </Link>
                              </li>
                              <li
                                className={`md:flex flex-col items-start block ${isExpanded["mobile-development"]
                                  ? "block"
                                  : "hidden"
                                  }`}
                              >
                                <Link
                                  to="/flutter-app-development/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Flutter
                                </Link>
                                <Link
                                  to="/ios-app-development/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  iOS
                                </Link>
                                <Link
                                  to="/android-app-development/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Android
                                </Link>
                                <Link
                                  to="/react-native-app-development/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  React Native
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <h6 className="text-lg text-black font-blancomedium mb-4 hidden md:block">
                              Concept/Design
                              <span className="inline-block text-orangecol">.</span>
                            </h6>
                            <ul>
                              <li
                                onClick={e => {
                                  getToggleMeClass("concept-design")
                                }}
                                className={`md:text-white font-gorditamedium text-base leading-[1.87rem] mb-2 relative md:hidden block ${isExpanded["concept-design"]
                                  ? "after:content-['-'] text-black"
                                  : "after:content-['+'] text-black"
                                  } after:relative after:ml-3 after:text-black md:after:hidden after:inline-block`}
                              >
                                Concept/Design
                              </li>
                              <li
                                className={`md:flex flex-col items-start block ${isExpanded["concept-design"]
                                  ? "block"
                                  : "hidden"
                                  }`}
                              >
                                <Link
                                  to="/wireframe-prototype/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Wireframes/Prototyping
                                </Link>
                                <Link
                                  to="/ui-development/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  UI Design
                                </Link>
                                <Link
                                  to="/responsive-web-design/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Responsive Design
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="md:w-auto w-full md:min-w-[6.875rem]">
                          <div className="md:mb-[7.5rem] mb-0">
                            <h6 className="text-lg text-black font-blancomedium mb-4 hidden md:block">
                              Cloud
                              <span className="inline-block text-orangecol">.</span>
                            </h6>
                            <ul>
                              <li
                                onClick={e => {
                                  getToggleMeClass("cloud-services")
                                }}
                                className={`md:text-white font-gorditamedium text-base leading-[1.87rem] mb-2 relative md:hidden block ${isExpanded["cloud-services"]
                                  ? "after:content-['-'] text-black"
                                  : "after:content-['+'] text-black"
                                  } after:relative after:ml-3 after:text-black md:after:hidden after:inline-block`}
                              >
                                Cloud
                              </li>
                              <li
                                className={`md:flex flex-col items-start block ${isExpanded["cloud-services"]
                                  ? "block"
                                  : "hidden"
                                  }`}
                              >
                                <Link
                                  to="/aws-cloud-services/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  AWS
                                </Link>
                                <Link
                                  to="/google-cloud-services/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Google Cloud
                                </Link>
                                <Link
                                  to="/aws-lambda-services/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  AWS Lambda
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <h6 className="text-lg text-blcak font-blancomedium mb-4 hidden md:block">
                              Trending
                              <span className="inline-block text-orangecol">.</span>
                            </h6>
                            <ul>
                              <li
                                onClick={e => {
                                  getToggleMeClass("trending")
                                }}
                                className={`md:text-white font-gorditamedium text-base leading-[1.87rem] mb-2 relative md:hidden block ${isExpanded["trending"]
                                  ? "after:content-['-'] text-black"
                                  : "after:content-['+'] text-black"
                                  } md:block after:relative after:ml-3 after:text-black md:after:hidden after:inline-block`}
                              >
                                Trending
                              </li>
                              <li
                                className={`md:flex flex-col items-start block ${isExpanded["trending"] ? "block" : "hidden"
                                  }`}
                              >
                                <Link
                                  to="/iot-application-development/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  IoT
                                </Link>
                                <Link
                                  to="/chatbot-development/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Chatbot
                                </Link>
                                <Link
                                  to="/blockchain-development/"
                                  onClick={toggleMenu}
                                  className="text-[#484848] font-gorditaregular md:text-[1rem] md-leading-[1.87rem] text-[0.813rem] leading-[1.87rem] hover:text-black transition-all w-auto block md:inline-block duration-500 hover:font-gorditamedium relative before:content[''] before:absolute before:left-0 before:bottom-[4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden"
                                >
                                  Blockchain
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </li>
                <li className="group relative lg:mx-4 md:mx-2 md:my-0 my-3.5 md:text-center text-left md:w-auto w-full">
                  <Link
                    to="/portfolio/"
                    onClick={toggleMenu}
                    className={` text-black md:text-base text-2xl relative before:content[''] before:absolute before:left-0 before:bottom-[-4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden font-gorditamedium group  ${colorChange || isWhiteNav
                      ? " md:text-black"
                      : "md:text-black"
                      } ${activePageClass('portfolio')}`}
                  >
                    <span className="relative">Work</span>
                  </Link>
                </li>
                <li className="lg:mx-4 md:mx-2 md:my-0 my-3.5 md:text-center text-left md:w-auto w-full">
                  <Link
                    to="/careers/"
                    onClick={toggleMenu}
                    className={` text-black md:text-base text-2xl relative before:content[''] before:absolute before:left-0 before:bottom-[-4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden font-gorditamedium group  ${colorChange || isWhiteNav
                      ? " md:text-black"
                      : "md:text-black"
                      } ${activePageClass('careers')}`}
                  >
                    <span className="relative">Careers</span>
                  </Link>
                </li>
                <li className="lg:mx-4 md:mx-2 md:my-0 my-3.5 md:text-center text-left md:w-auto w-full">
                  <a
                    href="/blog/"
                    onClick={toggleMenu}
                    className={` text-black md:text-base text-2xl relative before:content[''] before:absolute before:left-0 before:bottom-[-4px] before:w-0 before:h-[2px] before:bg-black hover:before:w-full max-md:before:hidden font-gorditamedium group  ${colorChange || isWhiteNav
                      ? " md:text-black"
                      : "md:text-black"
                      } ${activePageClass('blog')}`}
                  >
                    <span className="relative">Resources</span>
                  </a>
                </li>
                <li className="lg:ml-4 md:ml-3 mr-0 md:my-0 my-3 md:w-auto w-full md:text-center text-left">
                  {/* <Link
                    to="/contact-us/"
                    className="inline-flex items-center inline-white text-black border border-black text-base rounded-3xl pl-[1.313rem] py-1 pr-[0.313rem] font-gorditamedium hover:bg-primary hover:border-primary hover:text-white "
                  >
                    Contact Us
                    <span className="flex w-[1.875rem] h-[1.875rem] bg-primary justify-center items-center rounded-full ml-[0.625rem]">
                      <StaticImage src="../assets/img/edit.svg" alt="" />
                    </span>
                  </Link> */}

                  <Link
                    onClick={toggleMenu}
                    to="/contact-us/"
                    className="inline-flex items-center bg-white-200 justify-between inline-white text-black border border-black shadow-1xl text-base m-auto rounded-3xl pl-6 py-[0.313rem] pr-[0.313rem] font-gorditamedium leading-[1.313rem] hover:bg-transparent hover:border-primary group"
                  >
                    Contact Us
                    <span className="inline-flex w-[1.875rem] h-[1.875rem] bg-primary border-2 border-primary justify-center items-center rounded-full ml-[0.625rem] ease-in duration-300 group-hover:bg-transparent relative">
                      <img
                        src={animatedIconWhite}
                        alt=""
                        className="w-5 h-5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-100 visible group-hover:opacity-0 group-hover:invisible transition-all ease-in duration-300"
                      />
                      <img
                        src={animatedIcon}
                        alt=""
                        className="w-5 h-5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all ease-in duration-300"
                      />
                    </span>
                  </Link>
                </li>
              </ul>
            </nav>
            <div className="md:hidden block px-4 pb-10">
              <ul>
                <li className="flex flex-col pb-5">
                  <h3 className="font-blancomedium text-black pb-2 text-sm">
                    Inquires
                    <span className="inline-block text-orangecol">.</span>
                  </h3>
                  <a
                    href="mailto:sales@techuz.com"
                    className="text-[1.125rem] font-gorditamedium inline-block underline leading-[1.688rem] text-black transition-all duration-500 hover:font-gorditabold"
                  >
                    sales@techuz.com
                  </a>
                </li>
                <li className="flex flex-col pb-5">
                  <h3 className="font-blancomedium text-black pb-2 text-sm">
                    Reach us at
                    <span className="inline-block text-orangecol">.</span>
                  </h3>
                  <div className="flex items-center pb-2">
                    <span className="w-7 h-7 flex item-center justify-center mr-2 rounded-full items-center border border-[#D9D9D9] ">
                      <StaticImage src="../assets/img/wp.png" alt="" />
                    </span>
                    <a
                      href="tel:9512559090"
                      className="text-base font-gorditamedium text-black transition-all duration-500 hover:font-gorditabold"
                    >
                      +91 95125 59090
                    </a>
                    <span className="text-sm font-gorditamedium text-black ml-1">( Sales )</span>
                  </div>
                  <div className="flex items-center">
                    <span className="w-7 h-7 flex item-center justify-center mr-2 rounded-full items-center border border-[#D9D9D9]">
                      <StaticImage src="../assets/img/wp.png" alt="" />
                    </span>
                    <a
                      href="tel:9512559091"
                      className="text-base font-gorditamedium text-black transition-all duration-500 hover:font-gorditabold"
                    >
                      +91 95125 59091
                    </a>
                    <span className="text-sm font-gorditamedium text-black ml-1">( HR )</span>
                  </div>
                </li>
                <li className="flex flex-col pb-5">
                  <ul className="flex items-center pt-3">
                    <li>
                      <a
                        href="https://www.facebook.com/TechuzIT"
                        rel="dofollow"
                        target="_blank"
                        aria-label="Facebook"
                        className="text-[#888888] text-[1.375rem] mr-5 hover:text-black transition-all"
                      >
                        <FontAwesomeIcon icon={faFacebook} />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.twitter.com/TechuzIT"
                        rel="dofollow"
                        target="_blank"
                        aria-label="Twitter"
                        className="text-[#888888] text-[1.375rem] mr-5 hover:text-black transition-all"
                      >
                        <FontAwesomeIcon icon={faTwitter} />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://in.linkedin.com/company/techuz-infoweb-pvt-ltd"
                        rel="dofollow"
                        target="_blank"
                        aria-label="LinkedIn"
                        className="text-[#888888] text-[1.375rem] mr-5 hover:text-black transition-all"
                      >
                        <FontAwesomeIcon icon={faLinkedin} />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://dribbble.com/techuz"
                        rel="dofollow"
                        target="_blank"
                        aria-label="Dribbble"
                        className="text-[#888888] text-[1.375rem] mr-5 hover:text-black transition-all"
                      >
                        <FontAwesomeIcon icon={faDribbble} />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/techuz/"
                        rel="dofollow"
                        target="_blank"
                        aria-label="Instagram"
                        className="text-[#888888] text-[1.375rem] mr-5 hover:text-black transition-all"
                      >
                        <FontAwesomeIcon icon={faInstagram} />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.behance.net/techuzinfoweb"
                        rel="dofollow"
                        aria-label="Behance"
                        target="_blank"
                        className="text-[#888888] text-[1.375rem] mr-5 hover:text-black transition-all"
                      >
                        <FontAwesomeIcon icon={faBehance} />
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
